/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_SUPPORT_MATERIAL_TYPE } from "./actionTypes"
import { apiError, addSupportMaterialTypeSuccess } from "./actions"

//Include Both Helper File with needed methods
import { insertSupportMaterialType } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(insertSupportMaterialType, action.payload)
    if (response === undefined) throw new Error("API error")
    else yield put(addSupportMaterialTypeSuccess(response))
  } catch (error) {
    yield put(apiError(error.message))
  }
}

function* supportMaterialTypeAddSaga() {
  yield takeEvery(ADD_SUPPORT_MATERIAL_TYPE, add)
}

export default supportMaterialTypeAddSaga
